import {
  INDUSTRY_ALL_ID,
  type IndustryDto,
  isIndustryAllId,
  isIndustryAllSelection,
} from './models/industry.models';

export function mapIndustrySelectionFromApi(
  industries: readonly IndustryDto[] | undefined | null,
): string[] {
  if (!industries?.length) return [];
  if (industries.length === 1 && isIndustryAllId(industries[0].id)) {
    return [INDUSTRY_ALL_ID];
  }

  return industries
    .map((industry) => industry.id)
    .filter((industryId) => !isIndustryAllId(industryId));
}

export function mapIndustryLabelsFromApi(
  industries: readonly IndustryDto[] | undefined | null,
): Readonly<Record<string, string>> {
  if (!industries?.length) return {};
  const labels: Record<string, string> = {};
  for (const industry of industries) {
    labels[industry.id] = industry.name;
  }
  return labels;
}

/** Resolves a catalog display name (e.g. from AI suggestions) to an industry id. */
export function resolveIndustryIdByName(
  name: string,
  labels: Readonly<Record<string, string>>,
): string | null {
  const normalized = name.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  for (const [id, label] of Object.entries(labels)) {
    if (label.toLowerCase() === normalized) {
      return id;
    }
  }

  return null;
}

/** Collapses sub-industry ids to their parent industry id (deduped). */
export function normalizeIndustrySelectionToParentIds(
  values: readonly string[],
  subIndustryParentById: Readonly<Record<string, string>>,
): string[] {
  if (isIndustryAllSelection(values)) {
    return [...values];
  }

  const parentIds = new Set<string>();
  for (const id of values) {
    parentIds.add(subIndustryParentById[id] ?? id);
  }
  return [...parentIds];
}

export function mapIndustrySelectionToApi(
  values: readonly string[] | undefined | null,
): IndustryDto[] {
  if (!values?.length) return [];
  if (isIndustryAllSelection(values)) {
    return [{ id: INDUSTRY_ALL_ID, name: '' }];
  }

  return values.filter((value) => !isIndustryAllId(value)).map((id) => ({ id, name: '' }));
}
